module.exports = __webpack_public_path__ + "img/close.9fc7a860.png";